<form [formGroup]="changePasswordForm">
<div class="modal-header">
  <h5 class="modal-title"><i class="fa fa-lg fa-user" aria-hidden="true"></i> Change password </h5> <span>Username: <input type="text" formControlName="username"></span>
  <button type="button" class="close btn" data-dismiss="modal" aria-label="Close" (click)="cancelNewUserModal()">
    <span aria-hidden="true"><i class="fa fa-times"></i></span>
  </button>
</div>

  <div class="modal-body">

    <div class="form-group d-flex justify-content-center">
      <mat-form-field class="user-input" >
        <input name="password" matInput required type="password" placeholder="Password" formControlName="password" minlength="4">
        <mat-error *ngIf="changePasswordForm.hasError('required', 'password')">
          Please enter password
        </mat-error>

        <mat-error *ngIf="changePasswordForm.hasError('minlength', 'password')">
          Use at least 4 characters
        </mat-error>

      </mat-form-field>
    </div>

      <div class="form-group d-flex justify-content-center">
      <mat-form-field class="user-input">
        <input name="passwordAgain" matInput required type="password" placeholder="Password again" formControlName="passwordAgain">
        <mat-error *ngIf="changePasswordForm.hasError('required', 'passwordAgain')">
          Please enter password again
        </mat-error>

        <mat-error *ngIf="changePasswordForm.hasError('MatchPassword', 'passwordAgain')">
          Passwords do not match
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="modal-footer">
    <button class="greyButton" mat-raised-button color="primary" type="submit" id="changePassword" (click)="changePassword()">
      Change password
    </button>
  </div>
</form>
